import React from "react";
import ReactDOM from "react-dom";
import Main from "./Main";
import "./index.css";
 

ReactDOM.render(
  <Main/>, 
  document.getElementById("root")
);